import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    IconWarningOutline,
    Spacer,
    Text,
} from '@zillow/constellation';

import FraudFailure from 'app/shared/components/FraudFailure';
import PaidInclusionConstants from 'app/shared/constants/PaidInclusionConstants';

import './style.scss';

const PaidInclusionError = ({
    paymentFailErrorMessage,
    paymentPendingErrorMessage,
    initiateCardCaptureErrorMessage,
    verifyPaymentAndActivateListingErrorMessage,
    defaultErrorMessage,
    fraudErrorMessage,
}) => {
    const maintenanceModeErrorMessage = PaidInclusionConstants.ERROR_TYPE.METROID_MAINTENANCE_MODE;
    const isMaintenanceMode = paymentFailErrorMessage === maintenanceModeErrorMessage
        || initiateCardCaptureErrorMessage === maintenanceModeErrorMessage
        || verifyPaymentAndActivateListingErrorMessage === maintenanceModeErrorMessage;

    return (
        <div className="PaidInclusionError">
            <Spacer
                paddingX="md"
                paddingY="lg"
                className={`PaidInclusionError-header ${isMaintenanceMode ? 'maintenanceMode' : ''}`}
            >
                <IconWarningOutline fontColor="white" size="lg" />
            </Spacer>
            <Spacer padding="lg" className="PaidInclusionError-body">
                {fraudErrorMessage ? (
                    <FraudFailure />
                ) : (
                    <Text>
                        {initiateCardCaptureErrorMessage || paymentFailErrorMessage || paymentPendingErrorMessage
                        || verifyPaymentAndActivateListingErrorMessage || defaultErrorMessage}
                    </Text>
                )}
            </Spacer>
            <Spacer paddingBottom="sm">
                <Button fluid={true} buttonType="secondary" onClick={() => location.reload()}>
                    Reload page
                </Button>
            </Spacer>
        </div>
    );
};

PaidInclusionError.defaultProps = {
    defaultErrorMessage: PaidInclusionConstants.ERROR_TYPE.DEFAULT,
};

PaidInclusionError.propTypes = {
    paymentFailErrorMessage: PropTypes.string.isRequired,
    paymentPendingErrorMessage: PropTypes.string.isRequired,
    initiateCardCaptureErrorMessage: PropTypes.string.isRequired,
    defaultErrorMessage: PropTypes.string,
};

export default PaidInclusionError;
